import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ChecklistBuilder from './components/ChecklistBuilder';
import ChecklistPreview from './components/ChecklistPreview';
import CodeGenerator from './components/CodeGenerator';
import ImportExport from './components/ImportExport';
import './App.css';

function App() {
  const [checklists, setChecklists] = useState([]);
  const [activeChecklist, setActiveChecklist] = useState(null);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('n1p-checklists');
    if (saved) {
      const parsedChecklists = JSON.parse(saved);
      setChecklists(parsedChecklists);
      if (parsedChecklists.length > 0) {
        setActiveChecklist(parsedChecklists[0]);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('n1p-checklists', JSON.stringify(checklists));
  }, [checklists]);

  const createNewChecklist = () => {
    const newChecklist = {
      id: Date.now(),
      title: 'Nova Lista de Marcos',
      description: 'Descrição da sua lista de marcos',
      items: [
        {
          id: Date.now() + 1,
          title: 'Primeiro Marco',
          description: 'Descrição do primeiro marco',
          link: '',
          completed: false
        }
      ],
      createdAt: new Date().toISOString()
    };
    setChecklists([newChecklist, ...checklists]);
    setActiveChecklist(newChecklist);
  };

  const updateChecklist = (updatedChecklist) => {
    setChecklists(checklists.map(cl => 
      cl.id === updatedChecklist.id ? updatedChecklist : cl
    ));
    setActiveChecklist(updatedChecklist);
  };

  const deleteChecklist = (id) => {
    const filtered = checklists.filter(cl => cl.id !== id);
    setChecklists(filtered);
    if (activeChecklist?.id === id) {
      setActiveChecklist(filtered[0] || null);
    }
  };

  return (
    <Router>
      <div className={`min-h-screen transition-colors duration-300 ${
        darkMode ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'
      }`}>
        <Header 
          darkMode={darkMode} 
          setDarkMode={setDarkMode}
          onNewChecklist={createNewChecklist}
        />
        
        <div className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <ChecklistBuilder
                  checklists={checklists}
                  activeChecklist={activeChecklist}
                  setActiveChecklist={setActiveChecklist}
                  updateChecklist={updateChecklist}
                  deleteChecklist={deleteChecklist}
                  darkMode={darkMode}
                />
                <div className="space-y-6">
                  {activeChecklist && (
                    <>
                      <ChecklistPreview 
                        checklist={activeChecklist} 
                        darkMode={darkMode}
                      />
                      <CodeGenerator 
                        checklist={activeChecklist} 
                        darkMode={darkMode}
                      />
                    </>
                  )}
                </div>
              </div>
            } />
            <Route path="/import-export" element={
              <ImportExport
                checklists={checklists}
                setChecklists={setChecklists}
                darkMode={darkMode}
              />
            } />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;